import React from "react";
import moment from "moment";

const PaymentDetails = ({ paymentDetails }) => {
  const noDetails = paymentDetails.list;

  const convertUnixTime = (timestamp) =>
    moment.unix(timestamp).format("MMM DD YYYY");

  return (
    <section className="payment-details">
      <div className="payment-header">
        <h2 className="title">
          {noDetails ? "No Upcoming Payment" : "Payment Details"}
        </h2>
        <p className="info">
          {noDetails
            ? "You’re on the free Play plan, so you have to upcoming charges."
            : "You’re on the free Play plan, so you have to upcoming charges."}
        </p>
      </div>
      <div className="plan-info">
        <div className="plan-info-flex">
          <h2 className="heading">
            {noDetails
              ? "Play Plan"
              : paymentDetails.item_price_id === "Platform-Only-USD-Monthly"
              ? "Perform Plan (Monthly)"
              : "Perform Plan (Yearly)"}
          </h2>
          <p className="amount">
            {noDetails
              ? "$0.00"
              : `$${(paymentDetails.unit_price / 100).toFixed(2)} per User`}
          </p>
        </div>
        <div className="plan-info-flex">
          <h2 className="title">
            {noDetails ? "Up to 10 Teammates" : "Teammates"}
          </h2>
          <p className="amount">{noDetails ? "" : paymentDetails.quantity}</p>
        </div>
        {noDetails && (
          <div className="plan-info-flex mb-5">
            <h2 className="title">0 Team Blender Credits</h2>
            <p className="amount"></p>
          </div>
        )}
        <div className="plan-info-flex">
          <h2 className="heading">Tax</h2>
          <p className="amount">$0.00</p>
        </div>
        <div className="divider"></div>
        <div className="plan-info-flex">
          <h2 className="heading heading2">Next Payment</h2>
          <p className="amount">
            {noDetails
              ? "$0.00"
              : `$${(paymentDetails.amount / 100).toFixed(2)}`}
          </p>
        </div>
        <p className="off">
          {noDetails || paymentDetails.next_billing_at == null
            ? "Autopay turned off"
            : `Autopay on ${convertUnixTime(paymentDetails.next_billing_at)}`}
        </p>
      </div>
    </section>
  );
};

export default PaymentDetails;
